<template>
  <div>
    <b-table
      :items="parameters"
      :fields="fields"
      responsive
      striped
      bordered
      small
      class="mb-0"
      show-empty
      :empty-text="$t('Nenhum parâmetro neste grupo')"
    >
      <template #cell(name)="{ item }">
        <div v-if="item.name">{{ item.name }}</div>
        <em class="text-danger">{{ item.key }}</em>
      </template>

      <template #cell(value)="{ item }">
        <div v-if="item.value" class="text-muted" style="white-space: pre-wrap; word-break: break-all; max-width: 300px;">
          {{ truncateValue(item.value) }}
        </div>
        <span v-else class="text-muted">-</span>
      </template>

      <template #cell(actions)="{ item }">
        <e-grid-actions
          :show-update="$can('Update', 'Parameter')"
          :show-delete="false"
          @update="$emit('edit', item)"
        />
      </template>
    </b-table>
  </div>
</template>

<script>
import { BTable } from 'bootstrap-vue'
import { EGridActions } from '@/views/components'

export default {
  name: 'ParameterList',
  components: {
    BTable,
    EGridActions,
  },
  props: {
    parameters: {
      type: Array,
      default: () => [],
    },
    fetching: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fields: [
        { key: 'name', label: this.$t('Nome'), sortable: true },
        { key: 'value', label: this.$t('Valor'), sortable: false },
        { key: 'description', label: this.$t('Descrição'), sortable: false },
        { key: 'actions', label: this.$t('Ações'), thStyle: 'width: 100px;', tdClass: 'text-center' },
      ],
    }
  },
  methods: {
    truncateValue(value) {
      if (!value) return ''
      if (value.length > 100) {
        return `${value.substring(0, 100)}...`
      }
      return value
    },
    getTypeName(clrType) {
      if (!clrType) return ''
      // Extrair apenas o tipo sem o namespace
      const parts = clrType.split('.')
      let typeName = parts[parts.length - 1]
      // Remover `1 para tipos genéricos
      typeName = typeName.replace(/`\d+/, '')
      return typeName
    },
  },
}
</script>

<style scoped>
code {
  background-color: #f8f9fa;
  padding: 2px 4px;
  border-radius: 3px;
}

.badge {
  margin-right: 0.25rem;
  margin-bottom: 0.25rem;
}
</style>
